/**
 * Environment Configuration for Admin Panel
 *
 * This configuration reads from environment variables that are set via:
 * 1. .env.template file (populated by CI/CD pipeline)
 * 2. .env file (for local development - not committed to git)
 *
 * CI/CD Pipeline Usage:
 * The pipeline should use envsubst or similar tool to replace ${VARIABLE} placeholders
 * in .env.template with actual values from Azure DevOps Library Variable Groups.
 *
 * Example Pipeline Step:
 * - script: |
 *     envsubst < .env.template > .env
 *     npm run build
 *   env:
 *     API_BASE_URL: $(API_BASE_URL)
 *     ENVIRONMENT: $(ENVIRONMENT)
 */

const getConfig = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5050';
  const imageServiceUrl = process.env.REACT_APP_IMAGE_SERVICE_URL || baseUrl;
  const environment = process.env.REACT_APP_ENVIRONMENT || 'development';

  return {
    baseUrl,
    imageServiceUrl,
    environment,
  };
};

const config = getConfig();

export const { baseUrl, imageServiceUrl, environment } = config;

// Log configuration in non-production environments
if (environment !== 'production') {
  console.log('Admin Panel Configuration:', {
    baseUrl,
    imageServiceUrl,
    environment,
  });
}
